import { useEffect, useState } from 'react';

// https://js.plainenglish.io/state-management-with-react-hooks-no-redux-or-context-api-8b3035ceecf8

let listeners: any[] = [];
let state = {  };

const setState = (newState: any) => {
  state = { ...state, ...newState };
  listeners.forEach((listener) => {
    listener(state);
  });
};

export const useCustom = (): any => {
  const newListener = useState<number>()[1];

  useEffect(() => {
    listeners.push(newListener);
    return () => {
      listeners = listeners.filter(listener => newListener !== listener);
    };
  }, []);

  return [state, setState];
};